import React from 'react'
import { Button, Card, CardContent, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useCheckoutPaymentCompletedStyles } from './checkout-payment-completed.styles'

const thanksImageSrc = `${(process.env.PUBLIC_URL || '').replace(/\/$/, '')}/images/thanks.svg`

export type CheckoutPaymentCompletedProps = {
  receiptUrl: string
  onSearch: () => void
  onDonate: () => void
}

export const CheckoutPaymentCompleted: React.FC<
  CheckoutPaymentCompletedProps
> = ({ receiptUrl, onSearch, onDonate }) => {
  const { t } = useTranslation()
  const classes = useCheckoutPaymentCompletedStyles()

  return (
    <div className={classes.root}>
      <Card elevation={0} className={classes.cardMaxWidth}>
        <CardContent className={classes.cardContentPadding}>
          <div className={classes.contentStack}>
            <Typography component="h2" variant="h4" className={classes.headline}>
              {t('checkout.successDialog.headline')}
            </Typography>
            <Typography component="p" variant="body1" className={classes.subtitle}>
              {t('checkout.successDialog.subtitle')}
            </Typography>
            <img
              className={classes.illustration}
              src={thanksImageSrc}
              alt={t('checkout.successDialog.imageAlt')}
              width={384}
              height={300}
            />
            <div className={classes.actionsColumn}>
              <div className={classes.primaryRow}>
                <Button
                  href={receiptUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="contained"
                  color="primary"
                  fullWidth
                  className={classes.primaryRowButtonLayout}
                >
                  {t('checkout.successDialog.paymentInfo')}
                </Button>
                <Button
                  onClick={onSearch}
                  variant="contained"
                  color="primary"
                  fullWidth
                  className={classes.primaryRowButtonLayout}
                >
                  {t('checkout.successDialog.search')}
                </Button>
              </div>
              <Button
                onClick={onDonate}
                variant="outlined"
                color="primary"
                fullWidth
              >
                {t('checkout.successDialog.donationPage')}
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
